
import { User } from 'talkjs/all';
import Vue from 'vue';
import URLS from '~/URLS';
import { Tab } from '~/components/builders/Tabs.vue';
import Header from '~/components/layouts/Header.vue';
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import BillingService, { BillingAccount } from '~/services/BillingService';

export enum AccountTab {
    Settings = 'settings',
    Subscriptions = 'subscriptions',
    Purchases = 'purchases',
    Invoices = 'invoices',
    Payment = 'payment',
}

export default Vue.extend({
    name: 'Account',
    components: {
        Header,
        MainLayout,
    },
    data() {
        return {
            sections: AccountTab,

            billingAccount: null as BillingAccount | null,

            error: false,
        };
    },
    computed: {
        tabs(): Tab[] {
            return Object.values(AccountTab).map<Tab>(value => ({
                value,
                label: this.$t(`account.tabs.${value}`).toString(),
            }));
        },
        routerProps(): {
            billingAccount: BillingAccount | null;
        } {
            return {
                billingAccount: this.billingAccount,
            };
        },
        section(): AccountTab {
            switch (this.$route.path) {
                case URLS.accountSubscriptions:
                    return AccountTab.Subscriptions;
                case URLS.accountPurchases:
                    return AccountTab.Purchases;
                case URLS.accountInvoices:
                    return AccountTab.Invoices;
                case URLS.accountPayments:
                    return AccountTab.Payment;
                default:
                    return AccountTab.Settings;
            }
        },
        user(): User | null {
            return this.$store.getters['profileModule/getUser']();
        },
        headerLabel(): string {
            return this.$t('account.header').toString();
        },
    },
    methods: {
        onTabChange(value: AccountTab) {
            switch (value) {
                case AccountTab.Settings:
                    this.$router.push(URLS.account);
                    break;
                case AccountTab.Subscriptions:
                    this.$router.push(URLS.accountSubscriptions);
                    break;
                case AccountTab.Purchases:
                    this.$router.push(URLS.accountPurchases);
                    break;
                case AccountTab.Invoices:
                    this.$router.push(URLS.accountInvoices);
                    break;
                case AccountTab.Payment:
                    this.$router.push(URLS.accountPayments);
                    break;
            }
        },
    },
    mounted() {
        BillingService.getDefaultBillingAccount()
            .then(account => (this.billingAccount = account))
            .catch(err => {
                console.error(err);
                this.error = true;
            });
    },
});
